export default __webpack_public_path__ + "static/media/btn11.65935f46.webp";